import * as React from "react";
import { DataLayer } from "@grandvisionhq/analytics";
import { useTrackPageView } from "@grandvisionhq/svc-tealium/events";
import { bookAppointmentWhereStepScreenEvent } from "../../../../../data-layer/v3/data-layer/actions.js";
import { useAppointmentContext } from "../../../../../pages/BookAppointment/context/v3/pages/BookAppointment/context/AppointmentContext.js";
import { useRoutingContext } from "../../../../../pages/BookAppointment/context/RoutingContext/v3/pages/BookAppointment/context/RoutingContext/context.js";
import AppointmentLocation from "./AppointmentLocation.js";
import useBookAppointmentTypeWithUrlParam from "../../../../../pages/BookAppointment/hooks/v3/pages/BookAppointment/hooks/use-book-appointment-type-with-url-param.js";
const AppointmentLocationContainer = (props) => {
  const [{ setStore, setType, setTimeSlot }, { store, type, timeSlot }] = useAppointmentContext();
  const [, { queryParams }] = useRoutingContext();
  useBookAppointmentTypeWithUrlParam();
  const aabWherePageView = React.useCallback(
    () => Promise.resolve({
      id: "VirtualPage-View",
      Page_Type: "FindStore",
      Page_Section1: "Exam"
    }),
    []
  );
  useTrackPageView(aabWherePageView);
  React.useEffect(() => {
    if (store && !queryParams.storeId) {
      setStore(null);
    }
    if (type && !queryParams.typeId) {
      setType(null);
    }
    if (timeSlot && (!queryParams.start || !queryParams.end)) {
      setTimeSlot(null);
    }
  }, [queryParams, setStore, setType, setTimeSlot, store, type, timeSlot]);
  React.useEffect(() => {
    const dataLayerEvent = bookAppointmentWhereStepScreenEvent();
    DataLayer.pushEvent(dataLayerEvent);
  }, []);
  return /* @__PURE__ */ React.createElement(AppointmentLocation, { ...props });
};
export {
  AppointmentLocationContainer as default
};
//# sourceMappingURL=AppointmentLocationContainer.js.map
